import React from "react";

import Menu from "./Menu";
import { useForm } from 'react-hook-form';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { useEffect,useState } from "react";
import GIFLOADER from '../assets/loader.gif'
import Footer from "./Footer";
import NewUserIcon from '../assets/new-user.png';
import claim_list_api from '../api/claim_list_api.js';
import ForgotPassword from "./ForgotPassword.js";
import MobileMenu from "./MobileMenu.js";
import supabase from '../api/supabaseconnect';
import { useNavigate } from 'react-router-dom';
import {logout_api , reset_cancel_api} from '../api/logout_api.js';

const Login = () => {

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const navigate = useNavigate();


    var [suchidden, ShowSuc] = useState(true);
    var [errhidden, ShowErr] = useState(true);

    var [suMSG, SetSuMsg] = useState('');
    var [erMSG, SetErMsg] = useState('');

    var [btndis, SetBtnDisable] = useState(true);

    const [session, setSession] = React.useState(null)

    useEffect(() => {
        // window.history.forward();
        supabase.auth.getSession().then(({ data: { session } }) => {
          setSession(session)
        })
  
        const {
          data: { subscription },
        } = supabase.auth.onAuthStateChange((_event, session) => {
            console.log(session);
          setSession(session)
        })
  
        return () => subscription.unsubscribe()
      }, [])

    const ForgotSubmit = async () => {
        var user = await supabase.auth.getUser();

        if (!user) {
          console.error('User not authenticated.');
          return [];
        }
        let { data, error } = await supabase.from('test').select('*')
        if(error){
            var response_data = {"success":false,"msg":error.message}
        }else{
            response_data = {"success":true,"msg":"claim_list","data":data}
        }
        console.log(response_data);
        SetBtnDisable(btndis = false);

        if (response_data.success) {
            SetSuMsg(suMSG = response_data.msg);
            ShowSuc(!suchidden);
            setTimeout(() => {
                ShowSuc(suchidden = true);
            }, 3000);
            // event.target.reset();
            SetBtnDisable(btndis = true);
        } else {
            SetErMsg(suMSG = response_data.msg);
            ShowErr(!errhidden);
            setTimeout(() => {
                ShowErr(errhidden = true);
            }, 3000);
            SetBtnDisable(btndis = true);
        }
    }

    const SignSubmit = async () => {
        var response_data = await logout_api();
        console.log(response_data);
        SetBtnDisable(btndis = false);

        if (response_data.success) {
            SetSuMsg(suMSG = response_data.msg);
            ShowSuc(!suchidden);
            setTimeout(() => {
                ShowSuc(suchidden = true);
                navigate("/");
            }, 3000);
            SetBtnDisable(btndis = true);
        } else {
            SetErMsg(suMSG = response_data.msg);
            ShowErr(!errhidden);
            setTimeout(() => {
                ShowErr(errhidden = true);
            }, 3000);
            SetBtnDisable(btndis = true);
        }
    }

    if(!session){
        return navigate("/");
    }else{
        return (

            <div>
                <button type="button" className="btn login_btn btn-primary" onClick={handleSubmit(ForgotSubmit)}> Submit</button>
                <button type="button" className="btn login_btn btn-primary" onClick={handleSubmit(SignSubmit)}> sign out</button>
            </div>

        );
    }
};

export default Login;